module.exports = __webpack_public_path__ + "img/ellipsis.b2958b88.svg";